/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 31/07/13
 * Time: 10:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('Cure_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource( baseUrl + 'rest/cures/:id' , {} ,
            {
                query: { method: 'GET', isArray: true },
                get:   { method: 'GET' },
                getDeleted: { method: 'GET', isArray: true , url:baseUrl+'rest/cures/deleted'}
            }
        );
    }
    ]);

angular.module('FlexyBeautyApp.services')
    .factory('Cure',
        ["Cure_Resource", "ImageData", "CureData", "SupplierData", "CureCategoryData", "CompanyImageData", "ServiceData","HrRootCategory",
        function (Cure_Resource, ImageData, CureData, SupplierData, CureCategoryData, CompanyImageData, ServiceData,HrRootCategory) {
            var Cure = function(resource, parentCategory) {
                this.id = null;
                this.isDeleted;
                this.label = "";
                this.code = "";
                this.description= "";
                this.isOnHome= false;
                this.homeOrder= 0;
                this.price= null;
                this.hasInternetPrice= false;
                this.internetPrice= null;
                this.image = null;
                this.companyImage = null;
                this.specificImage = null;
                this.isVisibleOnWebSite = true;//Default;
                this.isBuyableOnWebSite = true;//Default;
                this.cureToServices = []; //{ _serviceId:2,quantity :12}
                this.serviceTab = [];
                this.version = null;
                if (resource) {
                    this.loadObject(resource);
                }
                if (parentCategory) {
                    this.parentCategory = parentCategory;
                }
                CureData.add(this);
            }

            Cure.prototype.loadObject = function(object, parentCategory) {
                //Assume here than the object in parameter contains only id (must load them)
                if (!this.id) {
                    this.id = object.id;
                }
                this.isDeleted = object.isDeleted;
                this.parentCategoryId = object.parentCategoryId;
                this.label = object.label;
                this.code = object.code;
                this.description = object.description;
                this.price = object.price;
                this.imageId = object.imageId;
                this.companyImageId = object.companyImageId;
                this.specificImage = object.specificImage;
                this.isOnHome = object.isOnHome;
                this.homeOrder = object.homeOrder;
                this.hasInternetPrice = object.hasInternetPrice;
                this.internetPrice = object.internetPrice;
                this.isVisibleOnWebSite = object.isVisibleOnWebSite;
                this.isBuyableOnWebSite = object.isBuyableOnWebSite;
                this.cureToServices = [];
                if (object.cureToServices) {
                    for (var i = 0; i < object.cureToServices.length; i++) {
                        this.cureToServices.push({
                            _serviceId: object.cureToServices[i].serviceId,
                            quantity: object.cureToServices[i].quantity
                        });
                    }
                }
                if (parentCategory) {
                    this.parentCategory = parentCategory;
                }
                if (object.version) {
                    this.version = object.version;
                }
            }

            Cure.prototype.getObjectResource = function()
            {
                var rsCure = new Cure_Resource();
                rsCure.id = this.id;
                rsCure.isDeleted = this.isDeleted;
                rsCure.code =this.code;
                rsCure.label =this.label;
                if (this.image)
                    rsCure.imageId = this.image.id;
                if (this.companyImage)
                    rsCure.companyImageId = this.companyImage.id;
                rsCure.specificImage = this.specificImage;
                rsCure.description = this.description ;
                rsCure.price= this.price;
                if (this.supplier!=null)
                    rsCure.supplier = this.supplier.getObjectResource();//Always allow update
                rsCure.isOnHome= this.isOnHome;
                rsCure.homeOrder= this.homeOrder;
                rsCure.hasInternetPrice= this.hasInternetPrice;
                rsCure.internetPrice= this.internetPrice;
                rsCure.isVisibleOnWebSite = this.isVisibleOnWebSite;
                rsCure.isBuyableOnWebSite = this.isBuyableOnWebSite;

                //needPhysicalResource &&  needHumanResource MANAGED BY SERVER
                if (this.parentCategory!=null)
                    rsCure.parentCategoryId = this.parentCategory.getId();
                rsCure.cureToServices = [];
                if (this.cureToServices)
                    for (var i=0;i<this.cureToServices.length;i++)
                        rsCure.cureToServices.push({serviceId:this.cureToServices[i].service.id,quantity:this.cureToServices[i].quantity})

                return rsCure;
            }

            Cure.prototype.loadRef =  function()
            {
                if (this.imageId)
                    this.image = ImageData.getById(this.imageId);
                if (this.companyImageId)
                    this.companyImage = CompanyImageData.getById(this.companyImageId);
                if (this.parentCategory==null && this.parentCategoryId)
                    this.parentCategory = CureCategoryData.getById(this.parentCategoryId);
                for (var i=0;i<this.cureToServices.length;i++)
                    if(this.cureToServices[i]) {
                        this.cureToServices[i].service = ServiceData.getById(this.cureToServices[i]._serviceId);
                        if(this.cureToServices[i].service) {
                            this.cureToServices[i].service.cures.push(this)
                            this.serviceTab.push(this.cureToServices[i].service);
                        }

                    }



            }

            Cure.prototype.getId = function()
            {
                return this.id;
            }

            Cure.prototype.setId = function(id)
            {
                this.id = id;
            }

            Cure.prototype.getLabel = function()
            {
                return this.label;
            }

            Cure.prototype.reload = function(endFunction)
            {
                var cureSrv = this.getObjectResource();
                var cure = this;
                if (this.getId()!=null)
                    cureSrv.$get({id:this.getId()}, //params
                        function (data) {   //success
                            cure.loadObject(data);
                            if (endFunction !=undefined)
                                endFunction(cure);
                        },
                        function (data) {   //failure
                            //error handling goes here
                            //TODO
                        });
            }

/*            Cure.prototype.isDescendantOf = function(category) {
                var isDescendantOf = false;
                if(category.cures) {
                    if (category.cures.indexOf(this) != -1) {
                        isDescendantOf = true;
                    }
                    else {
                        for (var i = 0; i < category.categories.length && !isDescendantOf; i++) {
                            isDescendantOf = isDescendantOf || this.isDescendantOf(category.categories[i]);
                        }
                    }
                }
                return isDescendantOf;
            }*/

            Cure.prototype.isDescendantOf = function(category) {
                var isDescendantOf = false;
                if(this.parentCategory === category) {
                    isDescendantOf = true;
                }
                else {
                    if(this.parentCategory) {
                        isDescendantOf = this.parentCategory.isDescendantOf(category);
                    }
                }

                return isDescendantOf;
            }

            return Cure;
        }
]);

angular.module('FlexyBeautyApp.services').
    factory('CureSrv',["$log","HumanResourceData","HumanResourceSrv","Cure_Resource","Cure","CureCategoryData","UserActionData","CureData","ServerSrv",
        function ($log,HumanResourceData,HumanResourceSrv,Cure_Resource,Cure,CureCategoryData,UserActionData,CureData,ServerSrv)
    {
        var cureSrv = {};
        cureSrv.save = function(cure,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(cureSrv.saveSync, cure, successFunction, errorFunction);
        };
        cureSrv.saveSync = function(cure,successFunction,errorFunction)
        {
            //$timeout (function () {

            var CureRes = cure.getObjectResource();
            CureRes.$save({}, //no params
                function (data) {
                    try{
                        if(cure.id == null) {
                            cure.setId(data.id);
                        }
                        if (!cure.version || (data.version && data.version > cure.version))
                            cure.version = data.version;
                        /** @namespace data.supplierId */
                        if (data.supplierId && cure.supplier)
                            cure.supplier.id = data.supplierId;

                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        }
        cureSrv.remove =  function(cure,successFunction,errorFunction)
        {
            CureData.remove(cure);
            ServerSrv.startSavingProcess(cureSrv.removeSync, cure, successFunction, errorFunction);
        };
        cureSrv.removeSync =  function(cure,successFunction,errorFunction)
        {
            //$timeout (function () {

            var cureRes = new Cure_Resource();
            cureRes.$remove({id:cure.getId()}, //params : id
                function (data) {
                    try{
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        }
        cureSrv.restore =  function(cure,successFunction,errorFunction)
        {
            CureData.restore(cure);
            ServerSrv.startSavingProcess(cureSrv.restoreSync, cure, successFunction, errorFunction);
        };
        cureSrv.restoreSync =  function(cure,successFunction,errorFunction)
        {
            //$timeout (function () {

            var cureRes = cure.getObjectResource();
            cureRes.$save({}, //params : id
                function (data) {
                    try{
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        }
        cureSrv.query = function(successFunction,errorFunction)
        {
            Cure_Resource.getDeleted(
                {}, //params
                function (data) {   //success
                    CureData.deletedCures = [];
                    for (var i=0;i< data.length;i++)
                        new Cure(data[i]);//Auto Add to CureData


                    if (successFunction!== undefined )
                        successFunction(CureData.categoryRoot);
                },
                function (data) {   //failure
                    $log.error("Cure_Resource.getDeleted error");
                    $log.error(data);
                    if (errorFunction!== undefined)
                        errorFunction(data);

                });
        }
        cureSrv.loadRef =  function()
        {
            var cures = CureData.indexCures;
            for (var i=0;i<cures.length;i++)
                cures[i].loadRef();

        }
        cureSrv.updateLocally =  function(id,object)
        {
            var cure =  null;
            var category = CureCategoryData.getById(object.parentCategoryId);
            if (category!=null)
                cure = category.getCureById(id)
            if (cure!=null)
            {
                cure.loadObject(object,category);
            }
            return cure
        }
        cureSrv.addLocally =  function(id,object)
        {
            var cure =  null;
            var category = CureCategoryData.getById(object.parentCategoryId);
            if (category!=null)
            {
                cure  = new Cure(object,category);
                cure.id = id;
                category.addCure();

            }
            return null;

        }
        cureSrv.removeLocally =  function(id,object)
        {
            var cure =  null;
            var category = CureCategoryData.getById(object.parentCategoryId);
            if (category!=null)
                cure = category.getCureById(id)
            if (cure!=null)
                category.removeCure(cure);
            return cure;
        }

        return cureSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services')
    .factory('CureData',
        ["$log", 
        function($log) {
            var cureData = {
                indexCures : [], //Used as Index
                deletedCures : []
            };

            cureData.getById = function(cureId) {
                let indexCure = this.indexCures.find( (element) => element.id == cureId);
                return (indexCure == undefined) ? null : indexCure;
            }

            cureData.getByIndex = function(servIndex) {
                if (servIndex >= 0 && servIndex < this.indexCures.length) {
                    return this.indexCures[servIndex];
                }
                return null;
            }

            cureData.getIndexOf = function(cure) {
                return (cure) ? this.indexCures.indexOf(cure) : -1;
            }
            
            cureData.add = function(cure) {
                this.indexCures.push(cure);
                if (cure.isDeleted) {
                    var index = this.deletedCures.indexOf(cure)
                    if (index == -1) {
                        this.deletedCures.push(cure);
                    }
                }
                return this.indexCures.length - 1;
            }
            
            //Soft Remove
            cureData.remove = function(cure) {
                var index = this.deletedCures.indexOf(cure);
                if (index == -1) {
                    this.deletedCures.push(cure)
                    cure.isDeleted = true;
                }
            }

            //Soft Remove
            cureData.restore = function(cure) {
                var index = this.deletedCures.indexOf(cure);
                if (index != -1) {
                    this.deletedCures.splice(index, 1)
                    cure.isDeleted = false;
                }
            }

            cureData.clear = function() {
                cureData.indexCures = [];
                cureData.deletedCures = [];
            }

            cureData.getDeletedList = function() {
                return cureData.deletedCures;
            }

            return cureData;
        }
]);



// WEBPACK FOOTER //
// ./js/services/models/Cure.js